var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 13.625C6.126 13.625 1 14.912 1 17.475V19.4H16.4V17.475C16.4 14.912 11.274 13.625 8.7 13.625ZM3.574 17.2C4.498 16.562 6.731 15.825 8.7 15.825C10.669 15.825 12.902 16.562 13.826 17.2H3.574ZM8.7 11.7C10.823 11.7 12.55 9.973 12.55 7.85C12.55 5.727 10.823 4 8.7 4C6.577 4 4.85 5.727 4.85 7.85C4.85 9.973 6.577 11.7 8.7 11.7ZM8.7 6.2C9.613 6.2 10.35 6.937 10.35 7.85C10.35 8.763 9.613 9.5 8.7 9.5C7.787 9.5 7.05 8.763 7.05 7.85C7.05 6.937 7.787 6.2 8.7 6.2ZM16.444 13.691C17.72 14.615 18.6 15.847 18.6 17.475V19.4H23V17.475C23 15.253 19.15 13.988 16.444 13.691ZM15.3 11.7C17.423 11.7 19.15 9.973 19.15 7.85C19.15 5.727 17.423 4 15.3 4C14.706 4 14.156 4.143 13.65 4.385C14.343 5.364 14.75 6.563 14.75 7.85C14.75 9.137 14.343 10.336 13.65 11.315C14.156 11.557 14.706 11.7 15.3 11.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.ea84a17d0cac862ae4f09636a49403b6.svg";
export { ForwardRef as ReactComponent };